module.exports = __webpack_public_path__ + "img/11.b6e82371.png";